module.exports = __webpack_public_path__ + "static/img/vip0.7fe59790.png";